export default {
  success: 'success'
}
